import React from 'react';
import { History } from 'lucide-react';

const eur = (n) => `€${Number(n || 0).toFixed(0)}`;

// Compact list of a guest's past stays (from the Beds24 archive) — used on the Arrival Desk card and in the folio.
export const PastStays = ({ history, stays, totalNights, totalSpend, favouriteRoom, testId = 'past-stays' }) => {
  const list = history || [];
  if (!list.length) return null;
  const rows = list.map((h) => (
    <li key={h.beds24_id || `${h.check_in}-${h.room_name}`} className="flex items-center justify-between gap-2 text-[11px]" data-testid={`${testId}-row-${h.beds24_id || h.check_in}`}>
      <span className="text-slate-700 whitespace-nowrap">{h.check_in} → {h.check_out}</span>
      <span className="text-slate-500 truncate flex-1">{h.room_name || '—'}{h.source ? ` · ${h.source}` : ''}</span>
      <span className="text-slate-500 whitespace-nowrap">{h.nights} n · <b className="text-slate-800">{eur(h.total_price)}</b></span>
    </li>
  ));
  const more = (stays || list.length) - list.length;
  return (
    <div className="rounded-lg border border-emerald-200 bg-emerald-50/60 p-2" data-testid={testId}>
      <p className="text-[10px] uppercase tracking-widest text-emerald-800 font-bold flex items-center gap-1 mb-1">
        <History className="w-3 h-3" /> Past stays · {stays || list.length} stay{(stays || list.length) === 1 ? '' : 's'}{totalNights ? ` · ${totalNights} nights` : ''}{totalSpend > 0 ? ` · ${eur(totalSpend)} lifetime` : ''}{favouriteRoom ? ` · loves ${favouriteRoom}` : ''}
      </p>
      <ul className="space-y-0.5">{rows}</ul>
      {more > 0 && <p className="text-[10px] text-slate-500 mt-1">+{more} earlier stay{more === 1 ? '' : 's'}</p>}
    </div>
  );
};

export default PastStays;
